// removed by extract-text-webpack-plugin
module.exports = {"text800":"_1tMKpfkBHFK9JLaOLsaPUo","text700":"_2sgV8eVubpzFTG1_Nkpd1z","text600":"_25gtH7VG4YrcnylU8owZG7","text500":"_2PUOIbKdjpfomtmKL2p5w1","text400":"_36rGZ49DijZ-Op3ej0rUwf","text300":"_3q5dsy2iuic92xjiTkT6OF","text200":"_40_AkZthgfB7sX8ggXtGT","textParagraph":"_2jP4H2huPUoApATg_neElP","crimp":"_3WS66vttTjPKgkvUi1iDRe","trim":"jS5VmBOYNfhInVyxfUzUD","flexCenter":"_3FY0oam_Dauc8EJ9kTDp4U","hideTextOverflow":"_18rCQXe2NLO6X746oyEiST","marginPageMainContent":"_1H2VhyfUUpPvU0uc5Kc3lT"};


//////////////////
// WEBPACK FOOTER
// ./src/imports/styles/extend.message.scss
// module id = 1331
// module chunks = 0